import dayjs, { Dayjs } from 'dayjs';

export const ABSOLUTE_DATE_TIME_FORMAT = 'MMM D, YYYY h:mm A';

const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

function formatAgo(count: number, unit: 'min' | 'hour'): string {
  return `${count} ${unit}${count === 1 ? '' : 's'} ago`;
}

/**
 * Human-friendly age for activity feeds: "Just now" under a minute, "5 mins ago"
 * under an hour, "23 hours ago" under a day, then the absolute date-time in the
 * user's local timezone ("May 4, 2026 3:45 PM"). Future timestamps (client/server
 * clock skew) collapse to "Just now". `now` is injectable for tests.
 */
export function formatRelativeDateTime(date: string | Date, now: Dayjs = dayjs()): string {
  const timestamp = dayjs(date);
  const minutesAgo = now.diff(timestamp, 'minute');
  if (minutesAgo < 1) {
    return 'Just now';
  }
  if (minutesAgo < MINUTES_IN_HOUR) {
    return formatAgo(minutesAgo, 'min');
  }
  const hoursAgo = now.diff(timestamp, 'hour');
  if (hoursAgo < HOURS_IN_DAY) {
    return formatAgo(hoursAgo, 'hour');
  }
  return timestamp.format(ABSOLUTE_DATE_TIME_FORMAT);
}
